module.exports = __webpack_public_path__ + "img/icn_brand5_black.3a1ed8ca.svg";